module.exports = __webpack_public_path__ + "media/images/badge/appassionato_secondary-821cdb7c04fce3a9d81a36738a7be289.png";